import api from '../api';
import { getFromSessionStorage } from '../../constants/functions';

export const saveAddressInformation = async (reqData: SaveAddressInformationReqProps) => {
  const url = `/vendedor/consorciado/registerOrUpdatePerson`;
  try {
    const res = (await api.post(url, reqData, {
      headers: { token: getFromSessionStorage('token') },
    })) as any;
    return res as { status: boolean; response: any };
  } catch (e) {
    return null;
  }
};

export const getAddressByCep = async (cep: string) => {
  const url = `/cep`;
  try {
    const res = (await api.get(url, {
      headers: { token: getFromSessionStorage('token') },
      params: { cep },
    })) as any;
    return res as {
      cep: string;
      rua: string;
      bairro: string;
      cidade: string;
      estado: string;
    };
  } catch (e) {
    return null;
  }
};

export interface SaveAddressInformationReqProps {
  cpfCnpj: string;
  person: {
    emails: string[];
    phones: string[];
    nome: string;
    type: string;
    faturamento: string;
    renda: string;
    sexo: string;
    estadoCivil: string;
    rg: string;
    nascimento: string;
    nacionalidade: string;
    naturalidade: string;
    txt_naturalidade_uf: string;
    pais_1: string;
    NIF_1: string;
    pais_2: string;
    NIF_2: string;
    informa_paises: string;
    pais_endereco: string;
    pais_resid_fiscal: string;
    pais_nacionalidade: string;
    tpdeclarado: string;
    pais_3: string;
    NIF_3: string;
    orgaoEmissor: string;
    informa_paises1: string;
    pais_endereco1: string;
    pais_resid_fiscal1: string;
    pais_nacionalidade1: string;
    tpdeclarado1: string;
    pais1_1: string;
    NIF1_1: string;
    pais1_2: string;
  };
  addresses: {
    zipCode: string;
    number: string;
    city: string;
    street: string;
    checked: boolean;
    neighborhood: string;
    state: string;
    complement: string;
  }[];
}
